var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoucherNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 119,
    viewBox: "0 0 117 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 35856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.0201 112.327C90.7613 112.327 113.25 89.838 113.25 62.0967C113.25 34.3554 90.7613 11.8667 63.0201 11.8667C35.2788 11.8667 12.79 34.3554 12.79 62.0967C12.79 89.838 35.2788 112.327 63.0201 112.327Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M52.97 44.7168C52.4 44.9268 51.83 45.1268 51.25 45.3068C45.8899 46.9668 40.74 46.7768 37.49 44.8168C36.41 44.1668 35.6099 43.3068 35.0599 42.3068C34.92 42.3568 34.77 42.4068 34.63 42.4468C26.59 45.0168 17.28 44.3268 9.73997 40.5868C9.27997 40.3568 9.08996 39.8068 9.31996 39.3468C9.54996 38.8868 10.0999 38.6968 10.5599 38.9268C17.6799 42.4568 26.4599 43.1068 34.0599 40.6768C34.16 40.6468 34.26 40.6168 34.36 40.5768C33.33 36.8868 34.6 32.1668 36.21 29.0268C37.3 26.9068 40.72 22.9768 44.05 23.0468C45.21 23.0768 46.82 23.5968 47.93 25.9868C49.67 29.7468 46.29 34.3168 45.21 35.6268C43.13 38.1568 40.2599 40.2068 36.8399 41.6368C37.2399 42.2668 37.77 42.8068 38.46 43.2268C41.27 44.9268 45.85 45.0368 50.72 43.5368C54.67 42.3068 64.44 38.1768 69.96 26.0968C70.17 25.6268 70.72 25.4268 71.19 25.6368C71.66 25.8468 71.86 26.3968 71.65 26.8668C67.79 35.2668 61.0499 41.6868 52.97 44.7168ZM42.82 25.1368C40.88 25.8668 38.73 28.1868 37.85 29.8868C36.47 32.5568 35.29 36.7768 36.1 39.9368C39.25 38.6268 41.87 36.7568 43.76 34.4568C45.63 32.1868 47.25 28.9768 46.23 26.7768C45.66 25.5368 44.93 24.9268 43.99 24.9068C43.63 24.8968 43.23 24.9768 42.82 25.1368Z",
    fill: "#0C1C3F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M74.5897 25.6868C74.5897 25.6868 71.4997 22.7368 74.8097 14.0468C78.1297 5.35682 88.6497 -1.33318 104.31 0.226825C104.31 0.226825 102.81 12.9268 90.2797 18.8168C90.2797 18.8168 87.7497 14.7968 84.5597 17.0468C80.1997 20.1168 83.3397 23.9068 83.3397 23.9068C83.3397 23.9068 80.9697 27.7968 74.5897 25.6868Z",
    fill: "#8BC53F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M82.6698 26.1069C79.1498 27.4269 74.9698 26.2069 74.7698 26.1469L74.0698 25.9369L74.1098 25.2069C74.1198 25.0669 74.9898 11.4269 90.4398 6.19694C90.9198 6.03694 91.4498 6.29694 91.6098 6.77694C91.7698 7.25694 91.5198 7.74694 91.0298 7.94694C78.6698 12.1269 76.4398 21.7469 76.0398 24.5469C77.3598 24.8269 80.1798 25.2169 82.3998 24.2069C81.6998 23.3069 80.8398 21.8369 80.9898 20.1969C81.1398 18.6869 82.0798 17.3969 83.7898 16.3569C85.1298 15.5469 86.4398 15.3569 87.6798 15.7869C89.2298 16.3269 90.2598 17.7369 90.7998 18.7169C93.4298 17.0069 101.43 11.0569 102.92 1.21693C103 0.706926 103.47 0.356927 103.97 0.436927C104.48 0.516927 104.82 0.98693 104.75 1.48693C102.83 14.1569 91.3398 20.5769 90.8498 20.8469L89.9098 21.3569L89.5298 20.3569C89.2898 19.7269 88.3698 17.9769 87.0498 17.5269C86.3498 17.2869 85.5898 17.4169 84.7398 17.9369C83.5598 18.6569 82.9098 19.4769 82.8198 20.3669C82.6598 22.0669 84.4298 23.7269 84.4498 23.7369L85.2898 24.5069L84.3698 25.1769C83.8598 25.5769 83.2698 25.8769 82.6698 26.1069Z",
    fill: "#0C1C3F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M110.45 73.4269C105.13 75.6369 99.39 74.5669 96.74 70.5169C93.66 65.7969 95.96 58.8269 101.88 54.9569C102.22 54.7369 102.56 54.5369 102.9 54.3469L95.31 36.3069C64.01 76.4269 1.5 68.7069 1.5 68.7069L7.45001 85.6469C9.03001 85.3069 10.73 85.2169 12.49 85.4269C19.52 86.2369 24.7 91.4369 24.05 97.0369C23.52 101.627 19.25 105.057 13.86 105.707L17.09 116.117C74.87 124.497 115.68 86.4969 115.68 86.4969L110.45 73.4269Z",
    fill: "white",
    stroke: "#0A1B3F",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.8301 79.2068L87.4401 91.1068",
    stroke: "#8BC53F",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M77.6479 75.3795C77.9654 72.6254 75.4252 70.0702 71.9742 69.6725C68.5233 69.2747 65.4684 71.185 65.151 73.9391C64.8335 76.6933 67.3737 79.2485 70.8247 79.6462C74.2756 80.044 77.3305 78.1337 77.6479 75.3795Z",
    stroke: "#8BC53F",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M57.5405 96.5707C57.858 93.8166 55.3178 91.2614 51.8668 90.8637C48.4159 90.4659 45.361 92.3762 45.0435 95.1303C44.7261 97.8845 47.2663 100.44 50.7172 100.837C54.1682 101.235 57.2231 99.3249 57.5405 96.5707Z",
    stroke: "#8BC53F",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherNotFound);
export default __webpack_public_path__ + "static/media/voucher_not_found.63084889be69a452e9008e3cdce7237f.svg";
export { ForwardRef as ReactComponent };